/**
 * wuTao
 * @description 作业记录信息查看
 * @Date  2020/11/06
 */
import React from "react";
import {connect} from "dva";
import {Card} from 'antd';
import {component_tool, framework_tool, utils_tool} from '@/tool';
import {modelUtils} from '@/utils';
import '@/styles/containers/internalTrain/homeworkrecord/style.less';
import PlayerContainer from "griffith";
import './homeworkrecordshow.less';
import { WizBraftEditorPlus } from "@/containers/common";

import './index.less'

let {WizContainer, ossFileUtils} = framework_tool;
let {
  WizCard, WizModal, WizList, WizTypography, WizButton, WizDivider, WizDescriptions,
  WizUpload, WizInput, WizSpin, WizRow, WizCol, WizTag, WizIcon,WizBraftEditor
} = component_tool;
let {Session, $$, checkStrLength} = utils_tool;
const {Title, Text, Paragraph} = WizTypography
const {TextArea} = WizInput;
const {Meta} = Card;
const getHomeworkRecord = (history) => {
  let id = null
  if (history.location && history.location.search) {
    // 从location中取出search
    let search = history.location.search
    // 这里是因为默认前面有一个?,切掉
    search = search.substr(1, search.length);
    search = search.substr(search.indexOf('=') + 1, search.length)
    id = search;
    Session.set('homeworkRecordInfoId', id);
  } else {
    id = Session.get('homeworkRecordInfoId') || null
  }
  return id
}

const getFile = (fileId, fileName, fileMimeType, fileSize, fileUri) => {
  let file = ossFileUtils.getOssFile(
    fileId, fileName, fileMimeType, fileSize, fileUri,
  );
  let urlNew = getOssFilePath(fileId);
  file.thumbUrl = urlNew;
  file.url = urlNew;
  return file;
}

const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

class HomeworkRecordShow extends WizContainer {

  componentName = 'homeworkRecordShow';

  constructor(props) {
    super(props);
    this.state = {
      previewImgVisible: false,
      previewImgKey: new Date().getTime(),
      previewImage: '',
      previewVideoVisible: false,
      previewVideo: {},
      previewVideoKey: new Date().getTime(),
      previewAudioVisible: false,
      previewAudio: {},
      previewAudioKey: new Date().getTime(),
      isShowMoreBut: null,
      requirementKey: new Date().getTime(),
    };
    this.id = getHomeworkRecord(props.history);
    this.initialValue = {};
    this.homworkInfo = {};
    this.requirementData = [];
    this.audioThumbUrl = constants.files.sys_icon_personal_homework_audio;
    this.videoThumbUrl = constants.files.sys_icon_personal_homework_video;
  }

  _componentDidMount() {
    if (this.id) {
      this._getHomeworkRecordInfo(this.id);
    }

  }

  //需要查询的接口
  /** 获取单挑作业详细设置信息*/
  _getHomeworkRecordInfo(id) {
    this.doAction({
      path: 'homeworkRecord/getInfo',
      payload: {
        key: "homeworkRecordInfo",
        apiParams: {
          id: id
        }
      }
    });
  }

  propsAndStateOnChange = {
    homeworkRecordInfo: this._getHomeworkRecordInfoOver.bind(this),

  }


  //得到返回接口的内容
  _getHomeworkRecordInfoOver(nextProps, nextState) {
    if (nextProps.homeworkRecordInfo.code == 1) {
      if (nextProps.homeworkRecordInfo.data) {
        let homeworkRecord = nextProps.homeworkRecordInfo.data;
        this.initialValue = homeworkRecord;
        if (homeworkRecord.id && homeworkRecord.homeworkId) {
          let homework = homeworkRecord.homeworkInfo;
          let requirementData = this._requirementData(homework);
          this.requirementData = requirementData;
          this.homworkInfo = homework;
          // this._getHomeworkInfo(homeworkRecord.homeworkId);
        } else {
          wizNotice.error('无效作业记录');
        }
      } else {
        wizNotice.error('无效作业记录');
      }
    } else {
      wizNotice.error(nextProps.homeworkRecordInfo.msg);
    }
    return true;
  }

  /** 获取作业要求数据*/
  _requirementData(homework) {
    const {audioMimes, imgMimes, fileMimes, videoMimes} = homework;
    let _data = [];
    if (imgMimes && imgMimes instanceof Array && imgMimes.length > 0) {
      imgMimes.forEach(item => _data.push(item))
    }
    if (videoMimes && videoMimes instanceof Array && videoMimes.length > 0) {
      videoMimes.forEach(item => _data.push(item))
    }
    if (audioMimes && audioMimes instanceof Array && audioMimes.length > 0) {
      audioMimes.forEach(item => _data.push(item))
    }
    let count = _data.length;
    if (fileMimes && fileMimes instanceof Array && fileMimes.length > count) {
      count = fileMimes.length;
    }
    if (count > 4) {
      this.setState({
        isShowMoreBut: false,
      });
    }
    return _data
  }

  _columns = () => [
    {
      title: '作业提交人',
      name: 'fullName',
      dataIndex: 'fullName',
      describeItem: {}
    },
    {
      title: '组织名称',
      name: 'orgName',
      dataIndex: 'orgName',
      describeItem: {}
    },
    {
      title: '组织代码',
      name: 'orgCode',
      dataIndex: 'orgCode',
      describeItem: {}
    },
    {
      title: '已选岗位',
      name: 'positionName',
      dataIndex: 'positionName',
      describeItem: {}
    },
  ]


  /** 学员基础信息*/
  _renderBase() {
    let initialValue = this.initialValue;
    if (initialValue && initialValue.id) {
      const wizDescriptionsProps = {
        record: initialValue,
        columns: this._columns(),
        column: { xs: 1, sm: 2, md: 3, lg: 4 },
      }
      return (
        // <div>
        //   <WizRow className={'baseScope-row-item'}>
        //     <WizCol className='col-item' span={2}>{'作业提交人：'}</WizCol>
        //     <WizCol span={4}><strong>{initialValue && initialValue.fullName}</strong></WizCol>
        //     <WizCol className='col-item' span={2}>{'组织名称：'}</WizCol>
        //     <WizCol span={4}><strong>{initialValue && initialValue.orgName}</strong></WizCol>
        //     <WizCol className='col-item' span={2}>{'组织代码：'}</WizCol>
        //     <WizCol span={4}><strong>{initialValue && initialValue.orgCode}</strong></WizCol>
        //     <WizCol className='col-item' span={2}>{'已选岗位：'}</WizCol>
        //     <WizCol span={4}><strong>{initialValue && initialValue.positionName}</strong></WizCol>
        //   </WizRow>
        // </div>
        <WizDescriptions {...wizDescriptionsProps} />
      )
    }
    return null

  }

  /** 作业要求*/
  _renderRequirement() {
    //let requirementArr = this.homworkInfo.requirement ? this.homworkInfo.requirement.split('\n') : [];
    if (this.homworkInfo.requirement && document.getElementById("homework_intro") != null) {
      document.getElementById(
        "homework_intro"
      ).innerHTML = WizBraftEditor.createEditorState(this.homworkInfo.requirement).toHTML();
    }
    return (
      <div id='homework_intro'>
        {
        // requirementArr && requirementArr.length > 0 ? (
        //   requirementArr.map((data, index) => {
        //     return (
        //       <WizRow key={'baseInfo_' + index} className={'requirement-height'}>
        //         <WizCol><strong>{data}</strong></WizCol>
        //       </WizRow>

        //     )
        //   })
        // ) : ''
        //<WizBraftEditorPlus key={new Date().getTime() } value={this.homworkInfo.requirement} disabled={true} />
        }
      </div>
    )
  }

  /** 作业要求列表*/
  _renderList() {
    let homework = this.homworkInfo;
    const {fileMimes} = homework;
    const data = this.requirementData;
    let _data = [];
    let _fileMimes = [];
    if (data.length > 0 || (fileMimes && fileMimes instanceof Array && fileMimes.length > 0)) {
      for (let i = 0; i < data.length; i++) {
        if (i > 3) {
          break;
        }
        _data.push(data[i]);
      }
      if (fileMimes && fileMimes instanceof Array && fileMimes.length > 0) {
        for (let i = 0; i < fileMimes.length; i++) {
          if (i > 0) {
            break;
          }
          _fileMimes.push(fileMimes[i]);
        }
      }
      return (
        <div className={'requirement-height'} key={'requirement_key_' + this.state.requirementKey}>
          <span className={'title-style'}><strong>附件:</strong></span>
          {this.state.isShowMoreBut != null && this.state.isShowMoreBut === false ? (
            <a className={'button-style'} onClick={e => this.setState({
              isShowMoreBut: true,
              //requirementKey: new Date().getTime(),
            })}><strong>展开</strong><WizIcon type="down"/></a>
          ) : (this.state.isShowMoreBut != null && this.state.isShowMoreBut === true ? (
            <a className={'button-style'} onClick={e => this.setState({
              isShowMoreBut: false,
              //requirementKey: new Date().getTime(),
            })}><strong>收起</strong><WizIcon type="up"/></a>
          ) : null)}
          {
            _data.length > 0 ? (
              <WizList grid={{gutter: 16, xs: 1, sm: 2, md: 3, lg: 4 }}
                       dataSource={this.state.isShowMoreBut === null || this.state.isShowMoreBut === false ? _data : data}
                       renderItem={this._renderRequirementItem}
              >
              </WizList>
            ) : ''
          }
          {
            _fileMimes.length > 0 ? (
              <WizList grid={{gutter: 16, xs: 2, sm: 3, md: 4, lg: 6 }}
                       dataSource={this.state.isShowMoreBut === null || this.state.isShowMoreBut === false ? _fileMimes : fileMimes}
                       renderItem={this._renderRequirementItem}
              >
              </WizList>
            ) : ''
          }
        </div>
      )
    } else {
      return ''
    }
  }

  _renderRequirementItem = (item, index) => {
    const {fileId, fileName, fileMimeType, fileSize, fileUri} = item;
    let file = getFile(fileId, fileName, fileMimeType, fileSize, fileUri);
    return (
      <WizList.Item className={'requirement-item-style'} key={'requirement_' + index}>
        {file && file.url ? (
          this._renderItemType(file, item, index)
        ) : ''}
      </WizList.Item>
    )
  }

  /** 展示组件*/
  _renderItemType(file, item, index) {
    const {fileId, fileName, fileMimeType, fileSize, fileUri} = item;
    let _fileName = checkStrLength(fileName,10);
    let thumbUrl;
    if (fileMimeType.indexOf('video/') != -1) {
      thumbUrl = this.videoThumbUrl;
    } else if (fileMimeType.indexOf('audio/') != -1) {
      thumbUrl = this.audioThumbUrl;
    }
    let fileList = [
      {
        ...file,
        uid: fileId + '_' + index,
        name: _fileName,
        status: 'done',
        thumbUrl: thumbUrl,
      }
    ]
    const fileProps = {
      disabled: true,
    }

    if (fileMimeType.indexOf('image/') != -1) {
      let imgProps = {
        ...file,
        uid: fileId + '_' + index,
        name: _fileName,
        status: 'done',
        thumbUrl: thumbUrl,
      }
      return (
        <Card className={'wizCard-title-span'} bordered={false} headStyle={{ backgroundColor: '#fd0' }} hoverable
              cover={<img alt="example" className={'images-view-style'} src={file.url} alt="avatar"/>}
              onClick={e => this.handlePreview(imgProps)}>
          <div className={'requirement-div-title'}><span>
              <font title={fileName}>{_fileName}</font>
            </span></div>
        </Card>
      )
    } else if (fileMimeType.indexOf('video/') != -1) {
      let videoProps = {
        url: file.url,
        title: _fileName,
        id: fileId,
        type: fileMimeType,
      }
      return (
        <>
          <Card className={'wizCard-title-span'} bordered={false}
                cover={<img alt="example" className={'images-view-style'} src={thumbUrl} alt="avatar"/>}
                onClick={e => this.handlePreviewVideo(videoProps)}
          >
            <div className={'requirement-div-title'}>
              <span>
                <font title={fileName}>{_fileName}</font>
              </span>
            </div>
          </Card>

        </>
      )
    } else if (fileMimeType.indexOf('audio/') != -1) {
      let audioProps = {
        url: file.url,
        title: _fileName,
        id: fileId,
        type: fileMimeType,
      }
      return (
        <>
          <Card className={'wizCard-title-span'} bordered={false}
                cover={<img alt="example" className={'images-view-style'} src={thumbUrl} alt="avatar"/>}
                onClick={e => this.handlePreviewAudio(audioProps)}
          >
            <div className={'requirement-div-title'}>
              <span>
                <font title={fileName}>{_fileName}</font>
              </span>
            </div>
          </Card>
        </>
      )
    } else {
      fileList = [
        {
          ...file,
          uid: fileId + '_' + index,
          name: <span className={'title-span'}><strong><span>
                <font title={fileName}>{_fileName}</font>
              </span></strong></span>,
          status: 'done',
          thumbUrl: thumbUrl,
        }
      ]
      return (
        <div className={'wizCard-file'} bordered={false}>
          <div className={'meta-title-span'}><WizUpload defaultFileList={[...fileList]} {...fileProps}/></div>
        </div>
      )
    }
  }

  /** 获取文件信息*/
  _getFileInfo(fileIdList, fileMimes) {
    let fileInfo = null;
    if (fileIdList && fileIdList instanceof Array && fileIdList.length > 0) {
      let _fileId = fileIdList[0];
      if (fileMimes && fileMimes instanceof Array && fileMimes.length > 0) {
        fileMimes.forEach(item => {
          const {fileId} = item;
          if (fileId && fileId === _fileId) {
            fileInfo = item;
          }
        })
      }
    }
    return fileInfo;
  }

  /** 加载作业*/
  _renderHomeworkRecord() {
    const _data = this._homeworkRecordData();
    return (
      <div>
        <WizList grid={{gutter: 16, column: 1}}
                 dataSource={_data}
                 renderItem={this._renderHomeworkRecordItem}
        >
        </WizList>
      </div>
    )
  }

  _renderHomeworkRecordItem = (item, index) => {
    const {type, fileList, content} = item;
    let orderDate = this._getHomeworkRecordOrder();
    return (
      <WizList.Item key={'homeworkRecordItem_' + index}>
        <WizCard>
          <div className="clearfix">
            <WizTypography className={'file-title-style'}>
              <Title level={4}>{'作业' + orderDate[index] + '：' + type}</Title>
              <Paragraph
                className={'file-title-style'}>{this._getHomeworkRecordDetail(type, fileList, content)}</Paragraph>
            </WizTypography>
          </div>
        </WizCard>
      </WizList.Item>
    )
  }

  _getHomeworkRecordDetail(type, fileList, content) {
    if (type === '文字') {
      return (
        <TextArea placeholder="请输入描述..." rows={4}
                  disabled={true} defaultValue={content}/>
      )
    } else if (type === '文件') {
      return (
        <WizList grid={{ gutter: 16, xs: 1, sm: 2, md: 4, lg: 6 }}
                 dataSource={fileList}
                 renderItem={this._renderHomeworkRecordDetailItem}
        >
        </WizList>
      )
    } else {
      return (
        <WizList grid={{ gutter: 16, xs: 1, sm: 2, md: 4, lg: 6 }}
                 dataSource={fileList}
                 renderItem={this._renderHomeworkRecordDetailItem}
        >
        </WizList>
      )
    }
  }

  _renderHomeworkRecordDetailItem = (item, index) => {
    const {fileId, fileName, fileMimeType, fileSize, fileUri} = item;
    let file = getFile(fileId, fileName, fileMimeType, fileSize, fileUri);
    let _fileName = checkStrLength(fileName,10);
    let thumbUrl;
    if(fileMimeType.indexOf('video/') != -1){
      thumbUrl = this.videoThumbUrl;
    } else if (fileMimeType.indexOf('audio/') != -1) {
      thumbUrl = this.audioThumbUrl;
    }
    let fileList = [
      {
        ...file,
        uid: fileId + '_' + index,
        name: <span className={'title-span'}><strong>
          <span>
                <font title={fileName}>{_fileName}</font>
          </span>
        </strong></span>,
        status: 'done',
        thumbUrl:thumbUrl,
      }
    ]
    const fileProps = {
      disabled: true,
    }
    if (fileMimeType.indexOf('image/') != -1) {
      let imgProps = {
        ...file,
        uid: fileId + '_' + index,
        name: _fileName,
        status: 'done',
        thumbUrl: thumbUrl,
      }
      return (
        <WizList.Item className={'requirement-item-style'} key={'homework_image_' + index}>
          <Card className={'wizCard-title-span'} bordered={false}
                cover={<img alt="example" className={'images-view-style'} src={file.url} alt="avatar"/>}
                onClick={e => this.handlePreview(imgProps)}>
            <div className={'requirement-div-title'}>
              <span>
                <font title={fileName}>{_fileName}</font>
              </span>
            </div>
          </Card>
        </WizList.Item>
      )
    } else if (fileMimeType.indexOf('video/') != -1) {
      let videoProps = {
        url: file.url,
        title: _fileName,
        id: fileId,
        type:fileMimeType,
      }
      return (
        <WizList.Item className={'requirement-item-style'} key={'homework_video_' + index}>
          <>
            <Card className={'wizCard-title-span'} bordered={false}
                  cover={<img alt="example" className={'images-view-style'} src={thumbUrl} alt="avatar"/>}
                  onClick={e => this.handlePreviewVideo(videoProps)}
            >
              <div className={'requirement-div-title'}>
                <span>
                  <font title={fileName}>{_fileName}</font>
                </span>
              </div>
            </Card>
          </>
        </WizList.Item>
      )
    } else if (fileMimeType.indexOf('audio/') != -1) {
      let audioProps = {
        url: file.url,
        title: _fileName,
        id: fileId,
        type:fileMimeType,
      }
      return (
        <WizList.Item className={'requirement-item-style'} key={'homework_audio_' + index}>
          <>
            <Card className={'wizCard-title-span'} bordered={false}
                  cover={<img alt="example" className={'images-view-style'} src={thumbUrl} alt="avatar"/>}
                  onClick={e => this.handlePreviewAudio(audioProps)}
            >
              <div className={'requirement-div-title'}>
                <span>
                  <font title={fileName}>{_fileName}</font>
                </span>
              </div>
            </Card>
          </>
        </WizList.Item>
      )
    } else {
      return (
        <WizList.Item>
          <WizUpload defaultFileList={[...fileList]} {...fileProps}/>
        </WizList.Item>
      )
    }
  }

  /** 打开图片查看*/
  handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    this.setState({
      previewImage: file.url || file.preview,
      previewImgVisible: true,
      previewImgKey: new Date().getTime(),
    });
  };

  /** 打开视频播放*/
  handlePreviewVideo = (videoProps) => {
    this.setState({
      previewVideoVisible: true,
      previewVideo: {...videoProps},
      previewVideoKey: new Date().getTime(),
    });
  };
  /** 打开音频播放*/
  handlePreviewAudio = (audioProps) => {
    this.setState({
      previewAudioVisible: true,
      previewAudio: {...audioProps},
      previewAudioKey: new Date().getTime(),
    });
  };

  /** 关闭查看Model*/
  handleCancel = () => this.setState({
    previewImgVisible: false,
    previewVideoVisible: false,
    previewAudioVisible: false,
  });

  _getHomeworkRecordOrder() {
    let orderData = [];
    orderData[0] = '一';
    orderData[1] = '二';
    orderData[2] = '三';
    orderData[3] = '四';
    orderData[4] = '五';
    return orderData;
  }

  /** 获取作业数据*/
  _homeworkRecordData() {
    let initialValue = this.initialValue;
    const {recordAudioList, recordFileList, recordImgList, recordVideoList, content} = initialValue;
    let _homeworkRecordData = [];
    if (content) {
      _homeworkRecordData.push({
        type: '文字',
        fileList: [],
        content: content,
      });
    }
    if (recordImgList && recordImgList instanceof Array && recordImgList.length > 0) {
      _homeworkRecordData.push({
        type: '图片',
        fileList: [...recordImgList],
        content: null,
      });
    }
    if (recordVideoList && recordVideoList instanceof Array && recordVideoList.length > 0) {
      _homeworkRecordData.push({
        type: '视频',
        fileList: [...recordVideoList],
        content: null,
      });
    }
    if (recordAudioList && recordAudioList instanceof Array && recordAudioList.length > 0) {
      _homeworkRecordData.push({
        type: '音频',
        fileList: [...recordAudioList],
        content: null,
      });
    }
    if (recordFileList && recordFileList instanceof Array && recordFileList.length > 0) {
      _homeworkRecordData.push({
        type: '文件',
        fileList: [...recordFileList],
        content: null,
      });
    }
    return _homeworkRecordData
  }

  _renderAudit() {
    const initialValue = this.initialValue || {};
    // let homworkInfo = this.homworkInfo;
    // const {comment, labels, labelAll, pass, score} = initialValue;
    // const {passScore, totalScore} = homworkInfo;
    // let labelList = [];
    // if (labels && labels instanceof Array && labels.length > 0) {
    //   labels.forEach(value => {
    //     labelList.push(value.title);
    //   })
    // }
    // if (!initialValue || !initialValue.id) {
    //   return ('');
    // }
    // let initialPass = '';
    // let initialScore = '';
    // if (pass === 1){
    //   initialPass = '已通过';
    // }else if (pass === 0){
    //   initialPass = '未通过';
    // }else{
    //   initialPass = '';
    // }
    // if (score!=null && score !=undefined && score !=-1){
    //   initialScore = score;
    // }

    const record = {
      homworkInfo: this.homworkInfo,
      ...initialValue
    }

    const columns = [
      {
        title: '考分提示',
        name: 'homworkInfo',
        dataIndex: 'homworkInfo',
        describeItem: {
          render: (text, record) => (
            <React.Fragment>
              {text.totalScore ? (<WizTag color={'#87d068'}>{'满分' + text.totalScore + '分'}</WizTag>) : null}
              {text.passScore ? (<WizTag color={'#878b86'}>{'及格' + text.passScore + '分'}</WizTag>) : null}
            </React.Fragment>
          )
        }
      },
      {
        title: '成绩',
        name: 'score',
        dataIndex: 'score',
        describeItem: {
          render: (text, record) => (record.score!=null && record.score !=undefined && record.score !=-1) ? record.score : null
        }
      },
      {
        title: '评语',
        name: 'comment',
        dataIndex: 'comment',
        describeItem: {}
      },
      {
        title: '是否通过',
        name: 'pass',
        dataIndex: 'pass',
        describeItem: {
          render: (text, record) => {
            return record&&record.pass===0 ? "未通过":record.pass===1 ? "通过":""
          }
        }
      },
      {
        title: '标签',
        name: 'labels',
        dataIndex: 'labels',
        describeItem: {
          render: (text, record) => {
            return text && Array.isArray(text) ? text.map(val => <WizTag><strong><font color={'#2db7f5'}>{val.title}</font></strong></WizTag>) : null
          }

          // labelList && labelList.length > 0 ? labelList.map(data =>
          //   <WizTag><strong><font color={'#2db7f5'}>{data}</font></strong></WizTag>
          // ) : null
        }
      }
    ]

    const wizDescriptionsProps = {
      record,
      columns,
      column: 1,
    }
    return (
      <WizDescriptions { ...wizDescriptionsProps } />
      // <WizList grid={{gutter: 16, column: 1}}>
      //   <WizList.Item>
      //     <WizRow className={'baseScope-row-item'}>
      //       <WizCol className='col-item' span={2}><strong>考分提示：</strong></WizCol>
      //       <WizCol span={16}>
      //         {totalScore ? (<WizTag color={'#87d068'}>{'满分' + totalScore + '分'}</WizTag>) : ''}
      //         {passScore ? (<WizTag color={'#878b86'}>{'及格' + passScore + '分'}</WizTag>) : ''}
      //       </WizCol>
      //     </WizRow>
      //   </WizList.Item>
      //   <WizList.Item>
      //     <WizRow className={'baseScope-row-item'}>
      //       <WizCol className='col-item' span={2}><strong>成绩：</strong></WizCol>
      //       <WizCol span={16}>{initialScore!='' ? initialScore + '分' : ''}</WizCol>
      //     </WizRow>
      //   </WizList.Item>
      //   <WizList.Item>
      //     <WizRow className={'baseScope-row-item'}>
      //       <WizCol className='col-item' span={2}><strong>评语：</strong></WizCol>
      //       <WizCol span={16}>{comment && comment}</WizCol>
      //     </WizRow>
      //   </WizList.Item>
      //   <WizList.Item>
      //     <WizRow className={'baseScope-row-item'}>
      //       <WizCol className='col-item' span={2}><strong>是否通过：</strong></WizCol>
      //       <WizCol span={16}>{initialPass}</WizCol>
      //     </WizRow>
      //   </WizList.Item>
      //   <WizList.Item>
      //     <WizRow className={'baseScope-row-item'}>
      //       <WizCol className='col-item' span={2}><strong>标签：</strong></WizCol>
      //       <WizCol span={16}>{
      //         labelList && labelList.length > 0 ? labelList.map(data =>
      //           <WizTag><strong><font color={'#2db7f5'}>{data}</font></strong></WizTag>
      //         ) : ''
      //       }</WizCol>
      //     </WizRow>
      //   </WizList.Item>
      // </WizList>
    )
  }

  _lookFile = (item) => {
  }
  /** 下载方法试用了很多但是都不能直接下载*/
  _downFile = (file) => {
    // this.getBlob(file.url, (blob) => {
    //   this.saveAs(blob, file.fileOriginalName);
    // });
    const win = window.open(file.url + '&download=y', '_blank');
    win.focus();
    // window.location.href = `${file.url}&download=y`
    // const a = document.createElement('a');
    // a.setAttribute('download',file.fileName)
    // a.setAttribute('href',file.url+'&action=download');
    // a.click();
    // a.setAttribute('href',file.url);
    // // a.href=window.URL.createObjectURL(file);
    // a.download=file.fileName;
    // document.body.appendChild(a);
    // const evt = document.createEvent('MouseEvents');
    // evt.initEvent('click',false,false);
    // a.dispatchEvent(evt);
    // document.body.removeChild(a);
    // a.setAttribute('download','')
    // a.setAttribute('href',file.url+'&action=download');
    // a.click();
  }

  _render() {
    let {homeworkRecordLoading, homeworkLoading} = this.props;
    return <div className="homeworkrecordshow-wrp">
      <WizSpin tip={'加载中'} spinning={homeworkRecordLoading || homeworkLoading}>
        <WizCard icon={'team'} title={'学员信息'}>
          {this._renderBase()}
        </WizCard>
        <WizCard icon={'ordered-list'} title={'作业要求'}>
          {this._renderRequirement()}
          {this._renderList()}
        </WizCard>
        <WizCard icon={'menu'} title={'作业内容'}>
          {this._renderHomeworkRecord()}
          <WizModal key={'img_preview_' + this.state.previewImgKey} visible={this.state.previewImgVisible} footer={null}
                    onCancel={this.handleCancel}>
            <img alt="example" style={{width: '100%'}} src={this.state.previewImage}/>
          </WizModal>
          <WizModal key={'video_preview_' + this.state.previewVideoKey} visible={this.state.previewVideoVisible}
                    footer={null}
                    onCancel={this.handleCancel}>
            { this.state.previewVideoVisible ? <Video {...this.state.previewVideo}/>: null }
          </WizModal>
          <WizModal key={'audio_preview_' + this.state.previewAudioKey} visible={this.state.previewAudioVisible}
                    footer={null}
                    onCancel={this.handleCancel}>
            {
              this.state.previewAudioVisible ? <Audio {...this.state.previewAudio}/> : null
            }
          </WizModal>
        </WizCard>
        <WizCard icon={'audit'} title={'批阅'}>
          {this._renderAudit()}
        </WizCard>
      </WizSpin>

    </div>

  }
}


const mapStateToProps = (state, ownProps) => {
  const {homeworkRecord, homework} = state;
  const homeworkRecordInfo = modelUtils.getModelEntity(homeworkRecord, "homeworkRecordInfo");
  const load = modelUtils.getLoadingState(state, ['homeworkRecord', 'homework']);
  return {
    homeworkRecordInfo: homeworkRecordInfo,
    ...load
  }
};

export default connect(mapStateToProps)(HomeworkRecordShow);

// 视频
function Video({url, id, title, type}) {
  const watermarkStyle = {
    color: "white",
    padding: "5px",
    position: "absolute",
    top: "30px",
    right: "10px",
    fontSize: "16px",
  };
  const sources = {
    // hd: {
    //   play_url: url,
    //   // bitrate: 0
    // },
    sd: {
      play_url: url,
    },
  };
  const videoProps = {
    id,
    standalone: true,
    title,
    // cover: require("@/assets/images/topbar-bg2.jpg"),
    duration: 25,
    sources,
    autoplay: true,
    locale: 'zh-Hans',
    shouldObserveResize: true,
    // src: "https://zhstatic.zhihu.com/cfe/griffith/zhihu2018_sd.mp4",
  };
  const videoPropsNew = {
    // cover: require("@/assets/images/topbar-bg2.jpg"),
    src:url,
    // src: "https://zhstatic.zhihu.com/cfe/griffith/zhihu2018_sd.mp4",
  };
  return (
    <div className="video-wrp video-style">
      <video {...videoPropsNew} controls={'controls'} preload={'preload'} ></video>
      {/* <PlayerContainer {...videoProps}/> */}
    </div>
  );
}

// 音频
function Audio({url, id, title, type}) {
  return (
    <Card key={'player_' + id} className={'audio-wizCard-title-span'} bordered={false}>
      <audio controls>
        <source src={url} type={type}/>
      </audio>
      <br/>
      <div className={'text-online'}><span>{title}</span></div>
    </Card>
  )
}
